// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"fn-z","badgeLink":"gn-z","category":"hn-z"};